import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: '15px',
    padding: '15px 0',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    marginTop: 'auto',
  },
  cardPaymentProcessingTime: {
    fontWeight: 700,
    fontSize: '12px',
  },
  withdrawalWarningContainer: {
    margin: '20px 0 0',
  },
}))
